// Study Hall rollout stages, shared by the server (which modes need the sandbox, when the start
// page may get the focus figure) and the start page (who sees that figure). Admission itself
// stays in src/server/lib/chat/index.js (admits), which follows the same ladder:
// off < staff < beta < open, with readonly as the kill switch.
//
//   pulse    /status/ping may carry the rounded "N focusing" figure
//   sandbox  the mode needs the view.* sandbox fully on (the owner can still force it)
//   line     who sees the figure on the start page: "used" = browsers that have opened Study
//            Hall, "signed-in" = anyone signed in, "" = nobody
const CLOSED = { pulse: false, sandbox: false, line: "" };
export const STAGES = Object.freeze({
	off: CLOSED,
	staff: CLOSED,
	readonly: CLOSED,
	beta: { pulse: true, sandbox: true, line: "used" },
	open: { pulse: true, sandbox: true, line: "signed-in" },
});
Object.values(STAGES).forEach(Object.freeze);
export const stageOf = (mode) => (Object.prototype.hasOwnProperty.call(STAGES, mode) ? STAGES[mode] : STAGES.off);

// Below this the figure is never published or shown (one or two people must not be spottable).
export const FOCUS_MIN = 5;

// Does this browser see the figure? p is the hall object from /status/ping (it carries the mode
// as `m`), already rounded on the server.
export function focusVisible(p, signedIn, usedHall) {
	if (!p || !(p.f >= FOCUS_MIN)) return false;
	const line = stageOf(p.m).line;
	return line === "signed-in" ? !!signedIn : line === "used" ? !!usedHall : false;
}

// The start-screen tile's short line: "15 focusing" ("" hides it).
export function tileText(p, signedIn, usedHall) {
	return focusVisible(p, signedIn, usedHall) ? p.f + " focusing" : "";
}

// The server request log still records two things that could reveal a site or a search
// (docs/chat/BETA-2026-10.md 8.5: search-suggestion text and the server connection's WebSocket
// address). Until both are fixed, the trust strip doesn't say "No browsing tracking".
export const BROWSING_LOGS_CLEAN = false;
